module.exports = __webpack_public_path__ + "static/img/deal@3x.9384f817.png";